import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './auth.state';

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectIsAuthenticated = createSelector(selectAuthState, s => s.isAuthenticated);
export const selectToken = createSelector(selectAuthState, s => s.token);
export const selectRoles = createSelector(selectAuthState, s => s.roles);

export const selectAuthLoading = createSelector(selectAuthState, s => s.loading);
export const selectAuthError = createSelector(selectAuthState, s => s.error);

export const selectHasRole = (role: string) =>
  createSelector(selectRoles, roles => roles.includes(role));
